import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { DUROLT_WEBSITE_LINK } from '../assets/constants/Constants';

const AboutScreenPage = () => {
    const { t } = useTranslation();
    const theme = useTheme();
    const appVersion = process.env.REACT_APP_RELEASE_VERSION; 

     return (
        <div className='about-screen-page'>
            <div className='main-container'>
                <div className='main'>
                    {t('aboutContent') !== 'aboutContent' ?
                    <div dangerouslySetInnerHTML={{__html: t('aboutContent')}}/> :
                    <>
                    <div className="container-about">
                        <p className='title' variant="h5">
                            {t('welcome_text')}
                        </p>
                        <p className='title' variant="body1">
                            {t('app_version_text')} {appVersion}
                        </p>
                    </div>

                    <div className="linking_group">
                        <p className='title' variant="body1">
                            {t('know_more_text')}
                        </p>
                        <a className='link-class' href={`${DUROLT_WEBSITE_LINK}`} color="primary">
                            {t('weblink_text')}
                        </a>
                    </div>
                        </>}
                </div>
            </div>
        </div>
    );
};

export default AboutScreenPage;